exports.Routes = {
  DebugTokenPage: (query) => ({ pathname: "/debugToken", query }),
  LogoutPage: (query) => ({ pathname: "/logout", query }),
  ContestEntryPage: (query) => ({ pathname: "/contests/[name]", query }),
  ClaimTicketPage: (query) => ({ pathname: "/tickets/claim", query }),
  GeneralClaimPage: (query) => ({ pathname: "/tickets/claimTicket", query }),
  ConsumeQRPage: (query) => ({ pathname: "/tickets/consume", query }),
  ViewQRPage: (query) => ({ pathname: "/tickets/view", query }),
  ViewTicketQRPage: (query) => ({ pathname: "/tickets/viewTicket", query }),
  EditContestPage: (query) => ({ pathname: "/creators/contests/[contestId]/edit", query }),
  ViewContestEntriesPage: (query) => ({ pathname: "/creators/contests/[contestId]", query }),
  ContestStartPage: (query) => ({ pathname: "/creators/contests/[contestId]/start", query }),
  CreatorContestListViewPage: (query) => ({ pathname: "/creators/contests", query }),
  NewContestPage: (query) => ({ pathname: "/creators/contests/new", query }),
  FeedbackViewPage: (query) => ({ pathname: "/creators/feedback", query }),
  DashboardPage: (query) => ({ pathname: "/creators", query }),
  CreatorLoginPage: (query) => ({ pathname: "/creators/login", query }),
  MediaMsgDetailsPage: (query) => ({ pathname: "/creators/media/[mediaMsgId]", query }),
  GoLivePage: (query) => ({ pathname: "/creators/media/goLive", query }),
  CreatorLiveBroadcastPage: (query) => ({ pathname: "/creators/media/liveBroadcast", query }),
  MediaUploadPage: (query) => ({ pathname: "/creators/media/upload", query }),
  CreatorOnboardPage: (query) => ({ pathname: "/creators/onboarding", query }),
  PushTextPage: (query) => ({ pathname: "/creators/pushText", query }),
  CreatorSettingsPage: (query) => ({ pathname: "/creators/settings", query }),
  VideosListPage: (query) => ({ pathname: "/creators/videos", query }),
  Page404: (query) => ({ pathname: "/404", query }),
  AUPPage: (query) => ({ pathname: "/aup", query }),
  CopyrightPage: (query) => ({ pathname: "/copyright", query }),
  FAQPage: (query) => ({ pathname: "/faq", query }),
  Landing: (query) => ({ pathname: "/", query }),
  MsgPage: (query) => ({ pathname: "/msg", query }),
  PrivacyPage: (query) => ({ pathname: "/privacy", query }),
  TermsPage: (query) => ({ pathname: "/tos", query }),
  SlugPage: (query) => ({ pathname: "/s/[slug]", query }),
  CheckoutRedirectPage: (query) => ({ pathname: "/co", query }),
  PoliticsCheckoutPage: (query) => ({ pathname: "/pco", query }),
  PortalRedirectPage: (query) => ({ pathname: "/po", query }),
  CreatorPublicContestsPage: (query) => ({ pathname: "/c/[name]/contests", query }),
  GoPage: (query) => ({ pathname: "/c/[name]/go", query }),
  CreatorPublicPage: (query) => ({ pathname: "/c/[name]", query }),
  WatchLivePage: (query) => ({ pathname: "/c/[name]/live", query }),
  LoginRedirectPage: (query) => ({ pathname: "/c/[name]/login", query }),
  FeedbackPage: (query) => ({ pathname: "/feedback", query }),
  Home: (query) => ({ pathname: "/home", query }),
  UserLoginPage: (query) => ({ pathname: "/login", query }),
  RecoverLoginPage: (query) => ({ pathname: "/recover", query }),
  WatchMuxPage: (query) => ({ pathname: "/wm", query })
}